import React from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { AppBar, Toolbar } from "@material-ui/core";

import FreshpaintLogoLight from "./components/FpLogoLight";
import HIPAABadgeSolid from "./components/HIPAABadgeSolid";
import { NavigationEnvironmentPicker } from "./EnvironmentPicker";
import useAccountMetadata from "./hooks/useAccountMetadata";
import { isAccountInHIPAAMode } from "./util";
import MasqueradeWarningBar from "./Topbar/MasqueradeWarningBar";

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: "none",
    backgroundColor: "#232F3E",
  },
}));

function Topbar({ className, ...rest }) {
  const classes = useStyles();
  const accountMetadata = useAccountMetadata();

  return (
    <AppBar {...rest} className={clsx(classes.root, className)} color="primary">
      <MasqueradeWarningBar />
      <Toolbar className="flex justify-between">
        <RouterLink to="/">
          <FreshpaintLogoLight height="36" />
        </RouterLink>
        {accountMetadata.loaded && isAccountInHIPAAMode(accountMetadata) && (
          <HIPAABadgeSolid />
        )}
        <NavigationEnvironmentPicker />
      </Toolbar>
    </AppBar>
  );
}

Topbar.propTypes = {
  className: PropTypes.string,
};

export default Topbar;
